module.exports = __webpack_public_path__ + "static/media/awen.ffd5bc77.png";